import ARC from './ARC.js';
export function defaultBroadcaster(isTestnet = false, config = {}) {
    return new ARC(isTestnet ? 'https://testnet.arc.gorillapool.io' : 'https://arc.gorillapool.io', config);
}
//# sourceMappingURL=DefaultBroadcaster.js.map